import type {
  AdvertiserDto,
  CreateAdvertiserRequest,
  SetProjectAdvertiserRequest,
  TgForumChatDto,
  UpdateAdvertiserRequest,
  UpsertTgForumChatRequest,
} from '@ledokol/contracts'
import { api } from './client'

/**
 * Эпик «TG-топики» — крупные рекламодатели + конфиг форум-чатов (admin).
 * tg_chat_id — ВЕЗДЕ string (BigInt-safe), без parseInt/Number на web.
 */

export async function fetchAdvertisers(): Promise<AdvertiserDto[]> {
  const r = await api.get<AdvertiserDto[]>('/advertisers')
  return r.data
}

export async function createAdvertiser(body: CreateAdvertiserRequest): Promise<AdvertiserDto> {
  const r = await api.post<AdvertiserDto>('/advertisers', body)
  return r.data
}

export async function updateAdvertiser(id: string, body: UpdateAdvertiserRequest): Promise<AdvertiserDto> {
  const r = await api.patch<AdvertiserDto>(`/advertisers/${id}`, body)
  return r.data
}

export async function deleteAdvertiser(id: string): Promise<void> {
  await api.delete(`/advertisers/${id}`)
}

/** Привязать/отвязать проект к рекламодателю (мульти-группа). advertiser_id=null → отвязать. */
export async function setProjectAdvertiser(projectId: string, body: SetProjectAdvertiserRequest): Promise<void> {
  await api.put(`/projects/${projectId}/advertiser`, body)
}

export async function fetchForumChat(tgChatId: string): Promise<TgForumChatDto | null> {
  const r = await api.get<TgForumChatDto | null>('/tg_forum_chats', { params: { tg_chat_id: tgChatId } })
  return r.data
}

export async function upsertForumChat(body: UpsertTgForumChatRequest): Promise<TgForumChatDto> {
  const r = await api.post<TgForumChatDto>('/tg_forum_chats', body)
  return r.data
}
